
@if (iShowFormulas) {
  <div style="border: solid">
    <div class="bg-light p-2 ps-5 mb-4 rounded" >
      <h5>LISTE DES FORMULES
        @if (!readOnlyService.isReadOnly()) {
          <button type="button" class="ms-5 btn btn-success"
            (click)="onShowFormula()">
            AJOUTER
          </button>
        }
        <div class="form-check form-check-inline" style="margin-left: 20%">
          <input class="form-check-input" type="checkbox" id="inlineCheckbox1" checked [(ngModel)]="showAllArticles"
            (change)="checkValue(showAllArticles)">
          <label class="form-check-label" for="inlineCheckbox1">Afficher tous les articles</label>
        </div>
      </h5>
    </div>
    <div class="container">
      <table class="table">
        <thead>
          <tr class="row">
            <th scope="col" class="col-auto">#</th>
            <th scope="col" class="col">ARTICLE</th>
            <th scope="col" class="col">PRIX</th>
            <th scope="col" class="col">NB HEURES</th>
            <th scope="col" class="col">BOITE</th>
            <th scope="col" class="col">DESCRIPTION</th>
            <th scope="col">STATUT</th>
          </tr>
        </thead>
        <tbody>
          @for (f of iFormulas; track f) {
            <tr class="row">
              @if (f.active || showAllArticles) {
                <th class="col-auto" scope="row">{{f.id}}</th>
              }
              @if (f.active || showAllArticles) {
                <td class="col">{{f.name}}</td>
              }
              @if (f.active || showAllArticles) {
                <td class="col">{{f.price}} €</td>
              }
              @if (f.active || showAllArticles) {
                <td class="col">{{f.nbHours}}</td>
              }
              @if (f.active || showAllArticles) {
                <td class="col">{{f.boxType}}</td>
              }
              @if (f.active || showAllArticles) {
                <td class="col">{{f.description}}</td>
              }
              @if (f.active || showAllArticles) {
                <td>
                  @if (f.active && !readOnlyService.isReadOnly()) {
                    <button type="button" class="btn btn-primary" (click)="activeArticle(f.id, true)">Activé</button>
                  }
                  @if (!f.active && !readOnlyService.isReadOnly()) {
                    <button type="button" class="btn btn-danger" (click)="activeArticle(f.id, false)">Désactivé</button>
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}

<app-formula-form (oFormulaSaved)="onFormulaSaved($event)"></app-formula-form>
